import { render, staticRenderFns } from "./MoleculeEditionProductPagesOfGratefulnessModalDelete.vue?vue&type=template&id=05f45bed&"
import script from "./MoleculeEditionProductPagesOfGratefulnessModalDelete.vue?vue&type=script&lang=js&"
export * from "./MoleculeEditionProductPagesOfGratefulnessModalDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports